import React from 'react';

import {createRoot} from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';

import App from './components/app/App';
/*The Create Rect App code for register service worker isn't quite set up correctly.
It also has us lacking our actual service-worker.js file, which I think actually belongs in the public folder.
It doesn't load correctly without tweaking.

When we get to doing a PWA we may need to start sorting this out, but for now it isn't working and is causing console errors.*/
//import registerServiceWorker from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const root = createRoot(rootElement);

root.render(
  <BrowserRouter basename={baseUrl}>
    <App />
  </BrowserRouter>
);

//registerServiceWorker();

